import React from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { initIpAddressSelector, isInitializedSelector } from "../../atoms";
import { isDevelopment } from "../../modules/config";

const disableAllowlist = isDevelopment() && false;

const useBannedlist = () => {
  const ok = useRecoilValue(isInitializedSelector);
  const ipAddress = useRecoilValue(initIpAddressSelector);

  return ok && Boolean(ipAddress);
};

const BannedRedirect = () => {
  const { location } = useHistory();
  const banned = useBannedlist();
  if (banned && location.pathname !== "/" && !disableAllowlist) {
    return <Redirect to="/blocked" />;
  }
  return null;
};

export default BannedRedirect;
